import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { api, formatError } from "@/lib/api";

const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="mb-2 block font-mono text-xs uppercase tracking-widest text-[#a3b1aa]">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-xs text-[#a3b1aa]">{hint}</span>}
  </label>
);

export const SettingsPanel = () => {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/settings").then((r) => setF(r.data)).catch(() => {});
  }, []);
  if (!f) return <p className="font-mono text-sm text-[#a3b1aa]">Caricamento…</p>;
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v?.target ? v.target.value : v }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings", {
        coaching_price: parseInt(f.coaching_price, 10), coaching_seats: parseInt(f.coaching_seats, 10),
        coaching_intro: f.coaching_intro || "", enrollment_open: !!f.enrollment_open,
      });
      setF(data);
      toast.success("Impostazioni salvate: il sito è aggiornato");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} data-testid="settings-form" className="max-w-2xl space-y-6">
      <p className="font-mono text-xs uppercase tracking-widest text-[#98bfa2]">Training online</p>
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Prezzo per partecipante (€)" hint="Vale per i nuovi link di pagamento. Chi ha già ricevuto il link paga il prezzo di allora.">
          <Input data-testid="settings-price" type="number" min={1} max={10000} required value={f.coaching_price} onChange={set("coaching_price")} className="h-12" />
        </Field>
        <Field label="Posti per percorso" hint={`Occupati ora: ${f.seats_taken ?? 0}`}>
          <Input data-testid="settings-seats" type="number" min={1} max={100} required value={f.coaching_seats} onChange={set("coaching_seats")} className="h-12" />
        </Field>
      </div>
      <Field label="Testo introduttivo della pagina Training" hint="Lascia vuoto per usare il testo standard.">
        <Textarea data-testid="settings-intro" rows={5} maxLength={1500} value={f.coaching_intro || ""} onChange={set("coaching_intro")} />
      </Field>
      <label className="flex items-center gap-3 text-sm">
        <Switch data-testid="settings-enrollment-open" checked={!!f.enrollment_open} onCheckedChange={set("enrollment_open")} />
        Iscrizioni aperte. Se le chiudi, la pagina mostra «Iscrizioni chiuse · lista d'attesa» e non si possono inviare nuovi link di pagamento.
      </label>
      <button data-testid="settings-save-btn" disabled={saving}
        className="bg-[#98bfa2] px-7 py-4 font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca] disabled:opacity-50">
        {saving ? "Salvataggio…" : "Salva impostazioni"}
      </button>
    </form>
  );
};
